import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/junk-removal-highland-ut")({
  beforeLoad: () => {
    throw redirect({
      href: "/services/junk-removal",
      statusCode: 301,
    });
  },
});
